// import 'intersection-observer'
import setScrollbarSize from './utils/setScrollbarSize'
import './polyfills'

import './assets'

import { createComponent } from '@bigyouth/base'

import 'lazysizes'
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks' // lazyload bgs with data-bg

/* eslint-disable-next-line */
import whatInput from 'what-input' // accessibility keyboard

import './style/styles-global.scss'
import * as features from './features/exports/global'

Object.values(features).forEach(createComponent)

// get scrollbarwidth (used for fixed header placement for instance)
// then you can use var(--scrollBarWidth) in sass files
setScrollbarSize()

// remove preload class on body (prevent flash of transitions when page is loading)
document.addEventListener('DOMContentLoaded', function () {
  document.body.classList.remove('preload')

  // for footer video
  if (window.innerWidth >= 1280 && document.querySelector('[js-video-footer]')) {
    document.querySelector('[js-video-footer]').setAttribute('autoplay', '')
  }

  // fix to set variable at 0 and make calculs work when no bar
  const wpAdminBarHeight = getComputedStyle(document.documentElement).getPropertyValue('--wp-admin--admin-bar--height')

  if (wpAdminBarHeight === '') {
    document.documentElement.style.setProperty('--wp-admin--admin-bar--height', '0px')
  }
  
  var lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy-background"));
  if ("IntersectionObserver" in window) {
    let lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          lazyBackgroundObserver.unobserve(entry.target);
        }
      });
    });

    lazyBackgrounds.forEach(function(lazyBackground) {
      lazyBackgroundObserver.observe(lazyBackground);
    });
  }
})
